import React from "react";
import Body from "./Body";

const Grants = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default Grants;
